import { DraggableList } from "@/components/draggable";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { T } from "@/i18n";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Plus } from "lucide-react";
import { Day } from "../../../-types";
import { Details } from "./details";
import { useReservationFormContext } from "../contex";

export function ScheduleTab() {
  const { scheduleManager, days } = useReservationFormContext();
  return (
    <div className="mx-auto grid w-full max-w-4xl gap-4">
      <div className="flex justify-end">
        <Button
          onClick={() => {
            scheduleManager.handleAddDay();
          }}
          className="cursor-pointer"
        >
          <Plus />
          <T tKey="reservations.form.schedule.newDay" />
        </Button>
      </div>
      <div className="grid gap-2">
        <DraggableList
          list={days}
          getId={(d) => d.reservationDay.value.id.toString()}
          onChange={(list) => {
            scheduleManager.handleReorderOfDays(
              list.map((d) => d.reservationDay.value.day),
            );
          }}
          render={(d) => (
            <DayComponent day={d} key={d.reservationDay.value.id} />
          )}
        />
      </div>
    </div>
  );
}

function DayComponent({ day }: { day: Day }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: day.reservationDay.value.id.toString() });

  return (
    <div
      className="flex items-start gap-2"
      ref={setNodeRef}
      style={{
        transition,
        transform: CSS.Transform.toString(transform),
      }}
    >
      <Button
        type="button"
        className="mt-2 cursor-grab"
        variant="ghost"
        {...attributes}
        {...listeners}
      >
        <GripVertical />
      </Button>
      <Accordion className="w-full" type="single" collapsible>
        <AccordionItem value={`day-${day.reservationDay.value.day}-content`}>
          <AccordionTrigger className="w-full">
            Day {day.reservationDay.value.day}{" "}
            {day.reservationDay.value.name ?? "-"}
          </AccordionTrigger>
          <AccordionContent>
            <Details day={day} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
